import client from '../client'

export const getDealerDetailsKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/getdealerdetails`

export async function getDealerDetails() {
  return client(getDealerDetailsKey)
}
